import { render, staticRenderFns } from "./index.vue?vue&type=template&id=768f05f4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=768f05f4&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=768f05f4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f05f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768f05f4')) {
      api.createRecord('768f05f4', component.options)
    } else {
      api.reload('768f05f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=768f05f4&scoped=true&", function () {
      api.rerender('768f05f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform/index.vue"
export default component.exports